const validateAnswer = function (errors, vm, showTip, valIndex) {
  const { answerConfig: { requireInd }, optionList } = this
  let optionListFilter = optionList.filter(item => item.visibility)

  if (requireInd === '1') {
    if (valIndex !== undefined && !optionListFilter[valIndex].value.trim()) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }

    if (valIndex === undefined && optionListFilter.some((item, index) => {
      return !item.value.trim()
    })) {
      errors.push(vm.cvtLang('tipAnswerNull', vm.surveyInfoLang.tipAnswerNull))
      return !errors.length
    }

  }

  return !errors.length
}

const validate = function (vm, showTip, valIndex) {
  const errors = []
  return {
    result: validateAnswer.call(this, errors, vm, showTip, valIndex),
    errors
  }
}

const answerValidate = {
  validateAnswer,
  validate
}

export default answerValidate



// WEBPACK FOOTER //
// ./src/components/editor/MultiFillBlankBox/answerValidate.js